import React from 'react';
import css from './style.module.scss';

export const TrialTariffNotification = () => (
	<div className={css.wrapper}>
		<div className={css.text}>Вы используете пробную версию WAKADOO</div>
		<a href="https://wakadoo.pro/tarif" target="blank" className={css.link}>Перейти к тарифам</a>
	</div>
);
